import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Link from 'components/Link';
import UserAvatar from 'components/UserAvatar';
import { AvatarShape } from 'entities';
import { getUserProfile } from 'selectors';
import './style.scss';

const MainNavigationDropdownHeader = props => {
  return (
    <div className="MainNavigationDropdownHeader">
      <div className="avatar">
        <UserAvatar letter={props.userName[0]} imageUrl={props.avatar.url} />
      </div>

      <div className="info">
        <div className="username">{props.userName}</div>
        <Link to="/settings">{__('members.navigation.settings')}</Link>
      </div>
    </div>
  );
};

MainNavigationDropdownHeader.propTypes = {
  userName: PropTypes.string,
  avatar: AvatarShape
};

const mapStateToProps = state => getUserProfile(state);

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainNavigationDropdownHeader);



/** WEBPACK FOOTER **
 ** ./src/members/Main/MainNavigation/MainNavigationDropdownHeader/index.js
 **/